import { ConfirmModal } from '@sparklayer-io/spark-dash-ui/components/confirm-modal';
import { t } from 'i18next';

export function SwitchToQuickSetupModal({
  isOpen,
  closeModal,
  onConfirm,
}: {
  isOpen: boolean;
  closeModal: () => void;
  onConfirm: () => void;
}) {
  return (
    <ConfirmModal
      isOpen={isOpen}
      onClose={closeModal}
      onConfirm={() => {
        onConfirm();
        closeModal();
      }}
      title={t(
        'features:customer_group.components.switch_to_quick_setup_modal.confirm_switch.title',
      )}
      confirmText={t(
        'features:customer_group.components.switch_to_quick_setup_modal.confirm_switch.confirm',
      )}
      message={t(
        'features:customer_group.components.switch_to_quick_setup_modal.confirm_switch.body',
      )}
    />
  );
}
